import Vue from 'vue'
import AscAutocompleteSelector from '@/components/molecules/AscAutocompleteSelector'

export default Vue.extend({
  components: {
    AscAutocompleteSelector,
  },

  data: function () {
    return {
      currentValue: [],
      items: [],
      disabled: true,
      sortItems: true,
    }
  },

  beforeMount() {
    if (this.params.selectedFilterValue?.length) {
      this.handleInput(this.params.selectedFilterValue)
    }
    if (this.params.ids && this.params.ids.length > 0) {
      this.currentValue = this.params.ids
    } else if (this.params.ids.length === 0) {
      this.currentValue = this.params.items?.map(x => x.text)
    }

    this.sortItems = !this.params.suppressDefaultSort

    if (this.params.items && this.params.items.length) {
      let filterSelections = []
      const items = this.params.items
      this.items = items || []
      this.disabled = !items.length
      // Persistent filter
      if (
        Object.prototype.hasOwnProperty.call(this.params, 'persistentGridId')
      ) {
        const persistentGridId = this.params.persistentGridId
        const filterModel = sessionStorage.getItem(`${persistentGridId}_filter`)
        if (filterModel) {
          const parsedFilterModel = JSON.parse(filterModel)
          if (
            Object.prototype.hasOwnProperty.call(
              parsedFilterModel,
              this.params.column.colId,
            )
          ) {
            const existingSelections =
              parsedFilterModel[this.params.column.colId].filter.split(',')

            if (existingSelections.length) {
              const validSelections = this.items.filter(item =>
                existingSelections.includes(item.text),
              )
              filterSelections = validSelections.map(
                selection => selection.text,
              )
            }
          }
        }
      } else {
        console.warn('N/A persistentGridId')
      }

      if (filterSelections.length) {
        this.handleInput(filterSelections)
      } else {
        // Select All
        this.currentValue = items.map(item => item.text)
      }
    }
  },

  methods: {
    handleInput(value) {
      this.currentValue = value
      // If something is checked you will have a length else set float filter to null/empty
      const valueToUse = this.currentValue.length
        ? this.currentValue.toString()
        : null

      this.params.parentFilterInstance(function (instance) {
        instance.onFloatingFilterChanged('set', valueToUse)
      })
    },
    onParentModelChanged(parentModel) {
      // setFilterModel should trigger this and hence we can update the float filters based on the parentmodel data
      if (parentModel && parentModel.filter) {
        this.currentValue = parentModel.filter.split(',')
      }
    },
  },

  template: `<div style="width: 100%">
  <asc-autocomplete-selector
    class="AscAgGridAutocompletePersistentFloatFilter"
    v-model="currentValue"
    :items="items"
    label="Features"
    component-type="multiple"
    float-filter
    use-strings
    :disabled="disabled"
    :sort-items="sortItems"
    @input="handleInput"
  />
</div>`,
})
